import { Facebook, Globe, Instagram, Twitter } from '@tamagui/lucide-icons';
import { Pressable } from '@unistocks/components/basic/pressable';
import { Center } from '@unistocks/components/layout/center';
import { Row } from '@unistocks/components/layout/flex';
import { Logo } from '@unistocks/components/logo/logo';
import { Modal } from '@unistocks/components/modal/modal';
import { Heading, Paragraph } from '@unistocks/components/text/text';
import { t } from '@unistocks/localization';
import { HOME_PAGE_URL } from '@unistocks/shared/consts';
import { applicationName, nativeApplicationVersion, nativeBuildVersion } from 'expo-application';
import { openURL } from 'expo-linking';
import { memo } from 'react';
import { DialogProps, isWeb } from 'tamagui';

export const AboutModal = memo<DialogProps>(props => {
  return (
    <Modal
      {...props}
      headerTitle={t('::Settings:About', { 0: applicationName })}
      adaptPlatform={false as any}
      adaptWhen={false}
    >
      <Center mx={'$4'} gap={'$5'}>
        <Heading size={'$6'} textAlign={'center'} onPress={() => openURL(HOME_PAGE_URL)}>
          {t('::Settings:About:Description', { 0: applicationName })}
        </Heading>

        <Logo height={'auto'} onPress={() => openURL(HOME_PAGE_URL)} />

        {/* Social media links */}
        <Row gap={'$5'} justifyContent={'center'}>
          <Pressable onPress={() => openURL(HOME_PAGE_URL)}>
            <Globe size={'$4.5'} color={'$unistocks'} />
          </Pressable>
          <Pressable onPress={() => openURL('https://www.facebook.com/unistocks')}>
            <Facebook size={'$4.5'} color={'#4267b2'} />
          </Pressable>
          <Pressable onPress={() => openURL('https://instagram.com/unistocksab')}>
            <Instagram size={'$4.5'} color={'#c13584'} />
          </Pressable>
          <Pressable onPress={() => openURL('https://x.com/unistocksab')}>
            <Twitter size={'$4.5'} color={'#1da1f2'} />
          </Pressable>
        </Row>
      </Center>

      {!isWeb ? (
        <Paragraph size={'$3'} mt={'$3'}>
          {applicationName} v.{nativeApplicationVersion} ({nativeBuildVersion})
        </Paragraph>
      ) : null}
    </Modal>
  );
});

AboutModal.displayName = 'AboutModal';
